// Cursor preference — persists the user's choice between the custom
// katana cursor (default) and the OS-native cursor. State lives in
// localStorage so it survives reloads, and a tiny pub/sub lets the
// global cursor injector in App.js react without prop drilling.

const KEY = "bc_cursor_pref";   // "katana" | "normal"
const subs = new Set();

export function getCursorPref() {
  try {
    const v = localStorage.getItem(KEY);
    return v === "normal" ? "normal" : "katana";
  } catch { return "katana"; }
}

export function setCursorPref(v) {
  const next = v === "normal" ? "normal" : "katana";
  try { localStorage.setItem(KEY, next); } catch { /* ignore */ }
  subs.forEach((fn) => { try { fn(next); } catch { /* ignore */ } });
}

export function toggleCursorPref() {
  setCursorPref(getCursorPref() === "katana" ? "normal" : "katana");
}

export function subscribeCursorPref(fn) {
  subs.add(fn);
  return () => subs.delete(fn);
}
